import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";

import styles from "./session-feedback-modal.module.scss";

interface SessionFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
}
interface SessionFeedbackSubmissionErrorProps {
  isOpen: boolean;
  onReSubmit: () => void;
  onCancelRetry: () => void;
  loading: boolean;
}
const SessionFeedbackModal = ({
  isOpen,
  onClose,
  onCancel,
}: SessionFeedbackModalProps) => {
  const { t } = useTranslation(["feedback", "common"]);

  return (
    <Modal
      isOpen={isOpen}
      style={{ width: "auto", maxWidth: "400px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
    >
      <ModalBody className={styles["body"]}>
        <p>{t("feedback:exitConfirm.question")}</p>
        <p>{t("feedback:exitConfirm.detail")}</p>
      </ModalBody>
      <ModalFooter className={styles["modal-footer"]}>
        <Button
          variant="enclosed-secondary"
          onClick={onCancel}
          className={styles.button}
        >
          {t("common:action.no")}
        </Button>
        <Button
          variant="enclosed-primary"
          onClick={onClose}
          className={styles.button}
        >
          {t("common:action.yes")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const SessionFeedbackSubmissionErrorModal = ({
  isOpen,
  onReSubmit,
  onCancelRetry,
  loading,
}: SessionFeedbackSubmissionErrorProps) => {
  const { t } = useTranslation(["feedback", "common"]);

  return (
    <Modal
      isOpen={isOpen}
      style={{ width: "auto", maxWidth: "400px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
    >
      <ModalBody className={styles["body"]}>
        <p>{t("feedback:submitError.message")}</p>
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        <Button variant="primary" onClick={onCancelRetry}>
          {t("common:action.cancel")}
        </Button>
        <Button
          variant="secondary"
          className="secondary-outlined"
          onClick={onReSubmit}
          loading={loading}
        >
          {t("common:action.tryAgain")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { SessionFeedbackModal, SessionFeedbackSubmissionErrorModal };
